module.exports = __webpack_public_path__ + "img/zizhi3.862102c5.jpg";